export const STATE = {
	IDLE:       'idle',
	CREATED:    'created',
	PROCESSING: 'processing',
	COMPLETED:  'completed',
	FAILED:     'failed',
	ABORTED:    'aborted',
};
